import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroupDirective } from '@angular/forms';
import { MatRadioChange, MAT_RADIO_DEFAULT_OPTIONS } from '@angular/material/radio';

import { SedsCheckFormTypeService } from '../../shared/services/seds-check-form-type/seds-check-form-type.service';
import { SedsRadioPosition } from './enums/seds-radio-positions.enum';
import { SedsRadioPositionType } from './types/seds-radio-positions.type';

@Component({
    selector: 'seds-radio-button',
    templateUrl: './seds-radio-button.component.html',
    styleUrls: ['./seds-radio-button.component.scss'],
    providers: [
        {
            provide: MAT_RADIO_DEFAULT_OPTIONS,
            useValue: { color: 'primary' },
        },
    ],
    standalone: false
})
export class SedsRadioButtonComponent implements OnInit {
  @Input() public controlName!: string;
  @Input() public disabled = false;
  @Input() public items?: Array<string>;
  @Input() public label?: string;
  @Input() public listPosition?: SedsRadioPositionType | SedsRadioPosition;
  @Input() public model?: string;
  @Output() modelChange = new EventEmitter<string>();

  public formControl!: FormControl;

  constructor(
    public checkFormTypeService: SedsCheckFormTypeService,
    private readonly rootFormGroup: FormGroupDirective
  ) {}

  ngOnInit() {
    this.checkReactiveForms();
  }

  public emitValue(radioGroup: MatRadioChange) {
    this.modelChange.emit(radioGroup.value);
  }

  private checkReactiveForms() {
    if (this.checkFormTypeService.isReactiveForm(this.model, this.controlName) && this.rootFormGroup.control) {
      this.formControl = this.rootFormGroup.control.get(this.controlName) as FormControl;
    }
  }
}
